const emojis: string[] = [
    '😂',
    '😍',
    '🤣',
    '😊',
    '🙏',

    '💕',
    '😭',
    '🔥',
    '😘',
    '👍',

    '🥰',
    '😎',
    '😆',
    '😁',
    '😉',

    '🤔',
    '😅',
    '😔',
    '🙄',
    '😜',

    '😒',
    '😩',
    '😁',
    '😩',
    '😒',

    '👌',
    '👏',
    '💔',
    '💖',
    '💙',

    '😢',
    '💪',
    '🤗',
    '💜',
    '😎',

    '😇',
    '🌹',
    '🤦',
    '🎉',
    '💞',

    '✨',
    '🤷',
    '😱',
    '😌',
    '🌸',

    '🙌',
    '😋',
    '🚗',
];

export { emojis };
